<template>
	<button class="view-ui-button-getstarted button-primary size-medium" v-on:click="$emit('continue')">
		Get Started
	</button>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Button
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiButtonGetStarted extends ViewBase {
		// Not implemented
	}
</script>
